export default (str, num) => {
    if (!str) return null;
    const n = num || 20;
    if (str.length <= n) {
        return str
    }
    return str.slice(0, n) + '...'
};
